/** The saved idea is context, not an assertion that the merchant's later edits remain evidence-backed. */
import type { StudyAuthoringRecord } from '@testfeed/shopify-contracts'
import { nextTestsCopy as copy } from '@testfeed/product-language'
import { buildDirectStudyResultsViewUrl } from '../../resultsNavigation'

export function NextTestDraftSource({ seed }: { seed: StudyAuthoringRecord['draft']['nextTestSeed'] }) {
  if (!seed) return null
  return (
    <s-section heading={copy.draftHeading}>
      <s-stack direction="block" gap="base">
        <s-paragraph>{seed.changedFactor}</s-paragraph>
        {seed.heldFixed.length > 0 && <s-text type="strong">{copy.draftFixed}</s-text>}
        {seed.heldFixed.map((text) => (
          <s-paragraph key={text}>{text}</s-paragraph>
        ))}
        <s-text type="strong">{copy.draftAlternatives}</s-text>
        {seed.alternatives.map((text) => (
          <s-paragraph key={text}>{text}</s-paragraph>
        ))}
        {seed.merchantDecisions.length > 0 && <s-text type="strong">{copy.draftDecisions}</s-text>}
        {seed.merchantDecisions.map((text) => (
          <s-paragraph key={text}>{text}</s-paragraph>
        ))}
        <s-paragraph color="subdued">{copy.draftReview}</s-paragraph>
        <s-button href={buildDirectStudyResultsViewUrl(seed.studyId, seed.runId)}>{copy.sourceResults}</s-button>
      </s-stack>
    </s-section>
  )
}
